import { render } from "./b2cUserFlight.vue?vue&type=template&id=d8ba9080&scoped=true"
import script from "./b2cUserFlight.vue?vue&type=script&lang=js"
export * from "./b2cUserFlight.vue?vue&type=script&lang=js"

import "./b2cUserFlight.vue?vue&type=style&index=0&id=d8ba9080&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8ba9080"]])

export default __exports__